<template>
  <div class="wx-user page-box">
    <div class="content-header top-line query-header">
      <el-row
        :gutter="10"
      >
        <el-col
          :lg="4"
          :md="6"
          :sm="24"
          :xs="24"
          class="el-col-el"
        >
          <el-select
            style="width: 100%"
            v-model="tagid"
            filterable
            clearable
            placeholder="用户标签"
            @change="tagChange"
          >
            <el-option
              v-for="(item,index) in tags"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-col>
        <el-col
          :lg="4"
          :md="6"
          :sm="24"
          :xs="24"
          class="el-col-el"
        >
          <el-input
            style="width: 100%"
            v-model="nickname"
            placeholder="昵称" clearable></el-input>
        </el-col>
        <el-col
          :lg="4"
          :md="6"
          :sm="24"
          :xs="24"
          class="el-col-el"
        >
          <el-input
            style="width: 100%"
            v-model="city"
            placeholder="城市"
            clearable
          ></el-input>
        </el-col>
        <el-col
          :lg="4"
          :md="6"
          :sm="24"
          :xs="24"
          class="el-col-el"
        >
          <el-input
            v-model="qrSceneStr"
            placeholder="关注场景值"
            clearable
          ></el-input>
        </el-col>
        <vs-button
          type="info"
          class="search-btn btn box-item"
          @click="searchHandle"
        >查询</vs-button>
        <vs-button
          v-if="isAuth('wx:wxuser:delete')"
          :disabled="selected.length < 1"
          class="mutil-btn "
          @click="deleteHandle()"
        >批量删除</vs-button>
      </el-row>
    </div>
    <div class="content-header header-bottom">
      <div class="header-left inner-flex">
        <vs-button
          :disabled="selected.length < 1"
          class="btn box-item"
          @click="bindTagHandle"
        >绑定标签</vs-button>
        <vs-button
          :disabled="selected.length < 1"
          class="btn box-item"
          @click="unBindTagHandle"
        >解绑标签</vs-button>
      </div>
      <div class="header-right inner-flex">
        <vs-button
          class="btn box-item"
          @click="tagManage"
        >
          <icon-svg
            icon-class="biaoqian"
            class="tag-manage"
          >
          </icon-svg>
          标签管理
        </vs-button>
          <vs-button
            class="btn box-item"
            @click="asycHandle"
          >
            <icon-svg
              icon-class="tongbu"
              class="asyc-fans"
            ></icon-svg>
            同步粉丝
          </vs-button>
      </div>
    </div>
    <div class="page-content">
      <div class="vs-table-outer">
        <vs-table
          multiple
          v-model="selected"
          :data="listData"
        >
          <template
            slot="thead">
            <vs-th>
              OPRNID
            </vs-th>
            <vs-th>
              昵称
            </vs-th>
            <vs-th>
              性别
            </vs-th>
            <vs-th>
              城市
            </vs-th>
            <vs-th>
              头像
            </vs-th>
            <vs-th>
              标签
            </vs-th>
            <vs-th>
              订阅时间
            </vs-th>
            <vs-th>
              场景值
            </vs-th>
            <vs-th>
              是否关注
            </vs-th>
            <vs-th>
              操作
            </vs-th>
          </template>
          <template slot-scope="{data}">
            <vs-tr
              v-for="(tr, index) in data"
              :key="index"
              :data="tr"
            >
              <vs-td>
                {{tr.openid}}
              </vs-td>
              <vs-td>
                {{tr.nickname}}
              </vs-td>
              <vs-td>
                {{getSex(tr)}}
              </vs-td>
              <vs-td
              >
                {{tr.city}}
              </vs-td>
              <vs-td>
                <img
                  class="headimg"
                  v-if="tr.headimgurl"
                  :src="tr.headimgurl" />
              </vs-td>
              <vs-td>
                <span
                  v-for="(tagid,index) in tr.tagidList"
                  :key="index"
                >{{getTagName(tagid)}}</span>
              </vs-td>
              <vs-td>
                {{parseTime(tr.subscribeTime)}}
              </vs-td>
              <vs-td>
                {{tr.qrSceneStr}}
              </vs-td>
              <vs-td>
                <span
                  class="self-tag"
                  :style="getStyle(tr)"
                >{{tr.subscribe ? "是":"否"}}</span>
              </vs-td>
              <vs-td>
                <el-button
                  v-if="isAuth('wx:wxuser:delete')"
                  type="text"
                  class="delete-btn"
                  @click="deleteHandle(tr.openid)">删除</el-button>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
      <div class="pagination-outer" v-if="total">
        <div class="paginnation-left">
          <size-change @sizeChange="sizeChange"></size-change>
          <span class="tatol-count">合计 {{total}} 条</span>
        </div>
        <vs-pagination
          class="pagination-box"
          :max="max"
          :total="pageSize"
          v-model="page"
        ></vs-pagination>
      </div>
    </div>
    <multiple-delete-dialog
      ref="muldelete"
      :ids="ids"
      @sure-delete="confirmDelete"
    ></multiple-delete-dialog>
    <wx-user-tags-manager
      ref="wxUserTagsEditor"
      :visible="showWxUserTagsEditor"
      @close="showWxUserTagsEditor=false"
    ></wx-user-tags-manager>
    <wx-user-tagging
      ref="wxUserTagging"
      :wx-users="selected"
      @do-success="doSuccess"
    ></wx-user-tagging>
  </div>
</template>

<script>
import WxUserTagsManager from '@/components/wx-user-tags-manager'
import wxUserTagging from '../../../components/wx/wx-user-tagging'
import multipleDeleteDialog from "@/components/public/multipleDeleteDialog";
import editMsgTplDialog from "../../../components/wx/msg-template/editMsgTplDialog";
import pushMsgDialog from "../../../components/wx/msg-template/pushMsgDialog";
import { mapGetters } from 'vuex'
import { colorRgba,parseTime } from '@/utils'
import initData from "@/mixins/initData";
import {deleteWxFans} from "../../../api/wx/wx-fan";
export default {
  name: "index",
  components: {
    pushMsgDialog,
    editMsgTplDialog,
    multipleDeleteDialog,
    wxUserTagging,
    WxUserTagsManager,
  },
  data() {
    return {
      selected: [],
      red: '#D85E5F',
      green: '#41B883',
      title: '',
      tagid: '',
      nickname: '',
      city: '',
      qrSceneStr: '',
      ids: [],
      showWxUserTagsEditor:false,
    }
  },
  mixins: [initData],
  computed: {
    ...mapGetters(['themeColor','userInfo','tags','selectedAppid']),
  },
  watch: {
    selectedAppid(newValue, oldValue) {
      if(newValue){
        this.searchHandle();
      }
    }
  },
  mounted(){
    this.searchHandle();
  },
  methods: {
    parseTime,
    tagChange(){
      this.toQuery();
    },
    beforeInit(){
      this.url = '/wx/manage/wxUser/list';
      this.params = {
        page: this.page,
        limit: this.size,
        'nickname': this.nickname,
        'tagid': this.tagid,
        'city': this.city,
        'qrSceneStr': this.qrSceneStr,
        'sidx': 'subscribe_time',
        'order': 'desc'
      }
      return true;
    },
    getWxUserTags(){
      this.$http({
        url: '/wx/manage/wxUserTags/list',
        method: 'get',
      }).then((data) => {
        if (data.code === 200) {
          this.$store.commit('updateTags', data.list)
        } else {
          this.$message.error(data.msg)
        }
      })
    },
    bindTagHandle(){
      this.$refs.wxUserTagging.init('tagging');
    },
    unBindTagHandle(){
      this.$refs.wxUserTagging.init('untagging');
    },
    asycHandle(){
      this.$http({
        url: '/wx/manage/wxUser/syncWxUsers',
        method: 'post',
      }).then((data) => {
        if (data.code === 200) {
          this.$message({
            message: '同步任务已建立，请稍候刷新查看列表',
            type: 'success',
            duration: 1500
          })
        } else {
          this.$message.error(data.msg)
        }
      })
    },
    getSex(tr){
      switch (tr.sex){
        case 0:
          return '未知';
        case 1:
          return '男';
        case 2:
          return '女';
      }
    },
    getTagName(tagid){
      let tag = this.tags.find( item => item.id == tagid);
      return tag ? tag.name : "-";
    },
    getStyle(tr){
      if(!tr.subscribe){
        return {
          backgroundColor: colorRgba(this.red ,0.1),
          color: this.red,
        };
      }else {

        return {
          backgroundColor: colorRgba(this.green,0.1),
          color: this.green,
        };
      }
    },
    tagManage(){
      this.$refs.wxUserTagsEditor.show();
    },
    deleteHandle(id){
      this.ids = id ? [id] : this.selected.map(item => item.openid);
      this.$refs.muldelete.dialogShow = true;
    },
    confirmDelete(ids){
      deleteWxFans(ids).then((res) => {
        this.$message({
          type: 'success',
          message: '已删除'
        });
        this.$refs.muldelete.dialogShow = false;
        this.searchHandle();
      })
    },
    doSuccess(){
      this.searchHandle();
    },
    searchHandle(){
      this.page = 1;
      this.init().then((res) => {
        res.page.list.forEach(element => {
          if(element.tagidList){
            element.tagidList = element.tagidList.split(',');
          }else {
            element.tagidList = [];
          }
        });
      });
    },
  },
}
</script>

<style lang="scss" scoped>
.wx-user {
  background-color: #f8f8f8;
  .headimg{
    width: 50px;
    height: 50px;
    border-radius: 8px;
  }

  .content-header,
  .page-content {
    background-color: #ffffff;
  }
  .content-header {
    padding-bottom: 10px;
  }
  .top-line {
    margin-bottom: 20px;
  }
  .asyc-fans,
  .tag-manage {
    margin-right: 5px;
  }


  .header-bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    .inner-flex {
      display: flex;
      &.header-left {
        justify-content: start;
      }
      &.header-right {
        justify-content: end;
      }
    }
  }


  .box-item {
    margin-bottom: 10px;
  }
  .btn {
    margin-right: 10px;
  }
  .vs-table-outer {
    .vs-con-table {
      min-width: 1200px;
    }
  }
  .tag-box {
    padding: 5px 10px;
    border-radius: 15px;
  }
}
</style>
